import { put, select } from 'redux-saga/effects'

import { setSearch } from '../../actions/ux'
import { setFeedQuery } from '../../actions/feed'
import { getFlyerGibsPage } from '../../actions/api'
import { selectIsFeedMode } from '../../selectors/feed'
import { selectFlyerId } from '../../selectors/campaign'

function* onProductsSearchType(action) {
  const { params: { search } } = action.payload

  yield put(setSearch(search))

  // feed mode: search is server side, results reset to page 1
  if (yield select(selectIsFeedMode)) {
    const flyerId = yield select(selectFlyerId)
    yield put(setFeedQuery(search))
    yield put(getFlyerGibsPage(flyerId, 1))
  }
}

export default onProductsSearchType
